export default {"src":"/_next/static/media/playing.d0c2c340.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};